import { PROTECTED_PATHS } from '../../../app/constants';
import {
  errorNotifier,
  successNotifier,
} from '../../../components/NotificationHandler';
import http, { AUTH_ROUTES } from '../../../services/api';

export const resetCode = async (payload, setLoading, setIsLoggedin) => {
  try {
    const { LOGIN } = PROTECTED_PATHS;
    setLoading(true);
    const {
      data: { result },
    } = await http.put(AUTH_ROUTES.UPDATE_TENANT_CODE, payload);
    console.log(result);

    // const token = result?.data?.token;
    // const userId = result?.data?.userId;

    // console.log("token", token)

    if (!result.success) return;
    // sessionStorage.setItem('11#221#', token);
    // sessionStorage.setItem('userId', userId);
    // navigate('/home');
    successNotifier(result.message);
    setLoading(false);
    setIsLoggedin(true);
    sessionStorage.clear();
    window.location.href = LOGIN;
  } catch (e) {
    setLoading(false);
    setIsLoggedin(false);
    console.log(e.response);
    // e.response?.data?.message
    //   ? errorNotifier(e.response?.data?.message)
    //   : errorNotifier(e.response?.data?.result?.message);
    if (e?.response) {
      e.response?.data?.message
        ? errorNotifier(e.response?.data?.message)
        : errorNotifier(e.response?.data?.result?.message);
    } else {
      errorNotifier('Please Check your network connection!!!');
    }
  }
};
